import { useInstance, onBeforeMount, onBeforeUpdate } from 'intact-vue-next';
export function useReceive(props, callback, ignoreInit) {
  if (ignoreInit === void 0) {
    ignoreInit = false;
  }
  var instance = useInstance();
  var shouldCall = false;
  props.forEach(function (prop) {
    instance.on("$receive:" + prop, function (newValue, oldValue, init) {
      if (ignoreInit && init) return;
      shouldCall = true;
    });
  });
  function call() {
    if (shouldCall) {
      callback();
      shouldCall = false;
    }
  }
  if (!ignoreInit) {
    onBeforeMount(call);
  }
  onBeforeUpdate(call);
}